import React, { ReactElement, Component, useContext, useEffect, useMemo } from "react";
import { injectIntl } from "react-intl";
import "./clusters-list.less";
import { ItemsContext, item } from "../../contexts/items";
import { CardSelectableContext } from "../../contexts/card-selectable";
// import { http_get } from "../../worker/http-func";
import TableList from "../../components/table-list/table-list";
import { TableDescContext } from "../../contexts/table-desc";
import { IsFreshContext } from "../../contexts/is_fresh";
import { http_request, destroy_worker } from "../../worker/http-func";
import { RolesContext, role_type } from "../../contexts/roles";
import { ClustersForPageContext } from "../../contexts/clusters-for-page";
import { TypeNameContext } from "../../contexts/type_name";
import { Row } from "antd";
import { UserInfoContext, IUserInfoType } from "../../contexts/user-info";
import { clusters_for_page_type } from "../../contexts/clusters-for-page";
import { ClusterContext, clusters_type_item } from "../../contexts/clusters";
import { DatacenternameContext } from "../../contexts/datacenter-name";
import { SortFirstContext } from "../../contexts/sort-first";

const ClustersList: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [clusters, set_clusters]: [clusters_type_item[], React.Dispatch<React.SetStateAction<clusters_type_item[]>>] = useContext(ClusterContext),
    [type_name, set_type_name]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useContext(TypeNameContext),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    set_items: React.Dispatch<React.SetStateAction<item[]>> = useContext(ItemsContext)[1],
    set_card_selectable: React.Dispatch<React.SetStateAction<boolean>> = useContext(CardSelectableContext)[1],
    is_fresh: boolean = useContext(IsFreshContext)[0],
    set_table_desc: React.Dispatch<React.SetStateAction<string[]>> = useContext(TableDescContext)[1],
    roles: role_type[] = useContext(RolesContext)[0],
    clusters_for_page: clusters_for_page_type | undefined = useContext(ClustersForPageContext)[0],
    datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
    sort_first: string = useContext(SortFirstContext)[0],

    { formatMessage } = useMemo(() => props.intl, [props]);
  // is_permitted = useMemo(() => role === 'globalAdmin' || role === 'clusterOwner', [role]);

  useEffect(
    () => () => {
      destroy_worker();
    },
    []
  );

  useEffect((): void => {
    (async (): Promise<void> => {
      let clusters_new: clusters_type_item[] | undefined;
      clusters_new = ((clusters_for_page || {}) as { [key: string]: clusters_type_item[] | undefined })[`clusters_for_${type_name}_clusters_page`];
      const urls: string[] = clusters_new
          ? clusters_new.map(({ metadata }: clusters_type_item): string => `/v1/datacenter/${datacenter_name}/cluster/${metadata.name}/info`)
          : [],
        role_arr: string[] | undefined = clusters_new?.map(
          ({ metadata }: clusters_type_item): string =>
            roles?.find(
              ({ cluster, roleName }: role_type) =>
                cluster === metadata.name && (roleName === "globalAdmin" || roleName === "clusterAdmin" || roleName === "clusterOwner")
            )?.roleName || ""
        );
      urls.length && datacenter_name &&
        http_request(
          "cluster_info",
          props,
          set_clusters,
          urls,
          0,
          roles?.length && role_arr ? role_arr : user_info.role,
          user_info.subscription_id,
          datacenter_name,
          "",
          undefined,
          clusters_new
        );
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clusters_for_page, type_name, datacenter_name, user_info.role, roles, set_clusters, user_info.subscription_id]);

  useEffect((): void => {
    if (type_name) {
      const get_length = (type_name_new: string): number | undefined =>
        ((clusters_for_page || {}) as { [key: string]: clusters_type_item[] | undefined })[`clusters_for_${type_name_new}_workspaces_page`]?.length;
      if (!get_length(type_name)) {
        const type_name_new: string = type_name === "dedicate" ? "shared" : "dedicate";
        get_length(type_name_new) !== undefined && (get_length(type_name_new) ? set_type_name(type_name_new) : props.history.push("/cluster-info/workspaces"));
      }
    } else {
      sessionStorage.getItem('sidebarKey')?.includes('shared') ? set_type_name('shared') : set_type_name('dedicate')
    }
  }, [props, type_name, set_type_name, clusters_for_page]);

  useEffect((): void => {
    set_card_selectable(true);
  }, [set_card_selectable]);

  useEffect((): void => {
    set_table_desc([`${formatMessage({ id: "clusters" })}`, `${formatMessage({ id: "clusters_desc" })}`]);
  }, [set_table_desc, formatMessage]);

  useEffect((): void => {
    if (Array.isArray(clusters) && (user_info.is_globaladmin || user_info.is_datacenteradmin  || user_info.is_clusteradmin || user_info.is_clusterowner) ) {
      const clusters_new: item[] =
        clusters &&
        clusters.map((cluster: clusters_type_item) => {
          // const { status }: clusters_type_item["status"] = cluster?.status;
          return (({
            name,
            agentVersion,
            key,
            selfLink,
            resourceVersion,
            generation,
            creationTimestamp,
            node,
            usedCPU,
            usedMemory,
            usedRootfs,
            usedPod,
            usedDisk,
            usedGPU,
            requestCPU,
            limitCPU,
            requestMemory,
            limitMemory,
            totalCPU,
            totalMemory,
            totalRootfs,
            totalPod,
            totalDisk,
            totalGPU,
            totalNamespaces,
            updateTime,
            createTime,
            status,
            clusteragentStatus,
          }) => ({
            name: name,
            version: agentVersion,
            key,
            uid: name,
            selfLink,
            resourceVersion,
            generation,
            creationTimestamp,
            node,
            totalNamespaces,
            cpu: { usedCPU, requestCPU, limitCPU, totalCPU },
            memory: { usedMemory, requestMemory, limitMemory, totalMemory },
            rootfs: { usedRootfs, totalRootfs },
            pod: { usedPod, totalPod },
            pvc: { usedDisk, totalDisk },
            gpu: { usedGPU, totalGPU },
            updateTime,
            createTime,
            status,
            clusteragentStatus,
            agentstatus: { status: status, agentStatus: clusteragentStatus}
          }))(cluster.metadata || {});
        });
      set_items(sort_first ? clusters_new.filter((item: item) => (item.name === sort_first)).concat(clusters_new.filter((item: item) => (item.name !== sort_first))) : clusters_new);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [set_items, is_fresh, clusters, user_info.is_globaladmin, user_info.is_datacenteradmin, user_info.is_clusteradmin, user_info.is_clusterowner]);

  return (
    <Row className="px-20 mt-10">
      <TableList />
    </Row>
  );
};

export default injectIntl(ClustersList);
